import React, { useContext, useEffect } from "react"
import CardTeam from "./CardTeam"
import CardTeamSkeleton from "./CardTeamSkeleton"
import { useTranslation } from "react-i18next"
import { useFetchApi } from "../../hooks"
import { LangContext } from "../../LangProvider"
import { LoadingHelper } from "../../components"

function TeamSection() {
  const { t } = useTranslation()
  const { lang } = useContext(LangContext)
  const [{ data: teams, loading }, doFetch] = useFetchApi(
    `/teams?lang=${lang}`,
    []
  )

  useEffect(() => {
    doFetch(`/teams?lang=${lang}`, [])
  }, [lang])

  return (
    <div className="uk-margin-large-bottom uk-container-large uk-container">
      <div className="uk-text-center">
        <h1 className="uk-margin-medium-bottom uk-text-bold font-red">
          {t("aboutus.meetTheTeam")}
        </h1>
      </div>
      <div
        className="uk-grid-match uk-padding-small uk-padding-remove-vertical uk-child-width-1-1@s uk-child-width-1-2@m"
        uk-grid="true"
      >
        {loading ? (
          <LoadingHelper numOfItems={6}>
            <CardTeamSkeleton />
          </LoadingHelper>
        ) : (
          teams.map((el, idx) => (
            <div key={idx}>
              <CardTeam person={el} />
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default TeamSection
